<template>
  <ValidationProvider name="選項" :rules="rules" v-slot="{ errors }">
    <div class="radio-button" :class="{ row: row, tabletColumn: tabletColumn }">
      <div
        v-for="(radio, radioIndex) in radioButtonItem.buttonItems"
        :key="radioIndex"
        :class="{ narrow: isNarrow }"
        class="container"
      >
        <label class="radio-button__label" :class="{ disable }">
          <input
            v-model="radioButtonValue"
            type="radio"
            :name="radioButtonItem.name ? radioButtonItem.name : radioName"
            :value="radio.id"
            class="radio-button__input"
            @change="$_changeValue()"
          />
          <i
            class="icon-radio-button-unchecked radio-button__icon"
            :class="{ disable, display: !$_isChecked(radio.id) }"
          />
          <i
            class="icon-radio-button-checked radio-button__icon"
            :class="{ disable, display: $_isChecked(radio.id) }"
          />
          <slot :radio="radio">
            <LvText
              :[textSize]="true"
              :lightGray="disable"
              class="text-label"
            >
              {{ $t(radio.textLabel) }}
            </LvText>
            <LlState
              v-if="radio.type"
              :value="state"
              :type="radio.type"
              :title="radio.title"
              :is-required="radio.require"
              :leading-icon="radio.leadingIcon"
              :rules="$_isSelected(radio.id, radio.rules)"
              class="mt-0"
              @input="$_onChangeState($event)"
            />
          </slot>
        </label>
        <slot name="outerContent" :radio="radio" />
      </div>
    </div>
    <div v-if="errors.length > 0" class="invalid-text">
      <i class="icon-warning invalid-icon" />
      <p v-for="(text_e, text_k) in errors" :key="text_k" class="text">
        {{ $t(text_e) }}
      </p>
    </div>
  </ValidationProvider>
</template>
<script>
export default {
  name: 'RadioButton',
  props: {
    radioButtonItem: {
      type: Object,
      default() {
        return {};
      },
    },
    radioName: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String],
      default: 0,
    },
    row: {
      type: Boolean,
      default: false,
    },
    tabletColumn: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    isNarrow: {
      type: Boolean,
      default: false,
    },
    state: {},
    disable: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: '',
    },
    textSize: {
      type: String,
      default: 'h4',
    },
  },
  data: () => ({
    checked_proxy: null,
  }),
  computed: {
    radioButtonValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.checked_proxy = val;
      },
    },
  },
  methods: {
    $_changeValue() {
      if (this.disable) return;
      this.$emit('input', this.checked_proxy);
    },
    $_onChangeState($event) {
      if (this.disable) return;
      this.$emit('ll-state', $event);
    },
    $_isSelected(radioValue, radioRules) {
      if (this.radioButtonValue === radioValue) {
        return radioRules;
      } else {
        return '';
      }
    },
    $_isChecked(radioId) {
      return this.value == radioId;
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/radio-button';
</style>
